import {TagIcon} from '@primer/octicons-react'
import {LABELS} from './constants/labels'
import {Blankslate} from '@primer/react/experimental'

export const EmptyState = ({noLabelsCreated}: {noLabelsCreated: boolean}) => {
  const title = noLabelsCreated ? LABELS.noLabelsCreatedTitle : LABELS.noMatchingLabelsTitle
  const description = noLabelsCreated ? LABELS.noLabelsCreatedDescription : LABELS.noMatchingLabelsDescription
  return (
    <Blankslate>
      <Blankslate.Visual>
        <TagIcon size="medium" />
      </Blankslate.Visual>
      <Blankslate.Heading as="h3">{title}</Blankslate.Heading>
      <Blankslate.Description>{description}</Blankslate.Description>
      {/* TODO: add new label will be handled separately */}
      {noLabelsCreated ? <Blankslate.PrimaryAction href="#">{LABELS.newLabel}</Blankslate.PrimaryAction> : null}
    </Blankslate>
  )
}

try{ EmptyState.displayName ||= 'EmptyState' } catch {}